/* Matapayals — animated rotating search placeholder ("keywords running" effect).
   Applies to any input with [data-mp-rotate="kw1, kw2, ..."]. Non-destructive:
   it never overwrites what the shopper is typing. */
(function () {
  'use strict';
  function init() {
    var inputs = document.querySelectorAll('[data-mp-rotate]');
    Array.prototype.forEach.call(inputs, function (input) {
      var kw = (input.getAttribute('data-mp-rotate') || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!kw.length) return;
      var prefix = input.getAttribute('data-mp-rotate-prefix');
      if (prefix == null) prefix = 'Search ';
      // Text mode: animate a non-input element's textContent (e.g. the search pill label)
      var isText = input.hasAttribute('data-mp-rotate-text');
      var i = 0;
      function swap() {
        if (!isText && document.activeElement === input && input.value) return; // don't disturb typing
        input.classList.add('mp-rotating--out');
        setTimeout(function () {
          if (isText) {
            input.textContent = prefix + kw[i] + '…';
          } else {
            input.setAttribute('placeholder', prefix + kw[i] + '…');
          }
          input.classList.remove('mp-rotating--out');
          i = (i + 1) % kw.length;
        }, 260);
      }
      swap();
      setInterval(swap, 2800);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
